import React, { createContext, useContext, useState, useEffect } from 'react';

const AdminAuthContext = createContext();

export const useAdminAuth = () => {
  const context = useContext(AdminAuthContext);
  if (!context) {
    throw new Error('useAdminAuth must be used within an AdminAuthProvider');
  }
  return context;
};

export const AdminAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for existing admin session on mount
    const adminToken = sessionStorage.getItem('adminToken');
    const adminInfo = localStorage.getItem('adminInfo');
    
    if (adminToken && adminInfo) {
      const parsedAdminInfo = JSON.parse(adminInfo);
      setAdmin(parsedAdminInfo);
    }
    setLoading(false);
  }, []);

  const login = (adminData) => {
    sessionStorage.setItem('adminToken', adminData.accessToken);
    localStorage.setItem('adminInfo', JSON.stringify({
      adminId: adminData.adminId,
      username: adminData.username,
      tokenType: adminData.tokenType
    }));
    setAdmin({
      adminId: adminData.adminId,
      username: adminData.username,
      tokenType: adminData.tokenType
    });
  };

  const logout = () => {
    sessionStorage.removeItem('adminToken');
    localStorage.removeItem('adminInfo');
    setAdmin(null);
  };

  const value = {
    admin,
    login,
    logout,
    loading
  };

  return (
    <AdminAuthContext.Provider value={value}>
      {children}
    </AdminAuthContext.Provider>
  );
};
